module.exports = __webpack_public_path__ + "img/SHProductManage.72776847.svg";